import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { NotificationReadStatus } from '../status/NotificationReadStatus';
import { NotificationWatcherCommentaryType } from '../../../notification.types';
import { sendNotificationClickedEvent } from '../../../notificationUtils';
import { StateType } from '../../../../../state/reducers';
import { NotificationWatcherTitle } from '../../title/NotificationWatcherTitle';
import { NotificationWatcherQuery } from '../../query/NotificationWatcherQuery';
import { NotificationLink } from '../../link/NotificationLink';
import { NotificationLinkContent } from '../../link/NotificationLinkContent';
import { NotificationLinkDate } from '../../link/NotificationLinkDate';

type Props = {
  notification: NotificationWatcherCommentaryType;
  notificationClicked: Function;
};

export const NotificationWatcherCommentary: FC<Props> = ({
  notificationClicked,
  notification,
}) => {
  const { isAlreadyRead } = useSelector(({ notifications }: StateType) => ({
    isAlreadyRead: !!notifications.notifReadStatusMap[notification.id],
  }));

  const onNotificationClicked = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    sendNotificationClickedEvent();
    notificationClicked(notification)(event);
  };

  const { watcherCommentary } = notification.data;
  return (
    <NotificationLink
      href={notification.link}
      onClick={onNotificationClicked}
      data-test-id="notification-watcher-decision"
    >
      <NotificationReadStatus notificationId={notification.id} />
      <NotificationLinkContent>
        <NotificationWatcherQuery isAlreadyRead={isAlreadyRead}>
          {watcherCommentary.query}
        </NotificationWatcherQuery>
        <NotificationWatcherTitle>
          {watcherCommentary.title}
        </NotificationWatcherTitle>
        <NotificationLinkDate>
          {formatShortDateFromNow(notification.date)}
        </NotificationLinkDate>
      </NotificationLinkContent>
    </NotificationLink>
  );
};
